import { Component, HostBinding, Input } from '@angular/core';
import { PivotSize } from './pivot-spinner.size';

@Component({
  selector: 'pivot-spinner',
  templateUrl: './pivot-spinner.component.html',
  styleUrls: ['./pivot-spinner.component.scss'],
})

export class PivotSpinnerComponent {

  @Input() inside: boolean;

  @Input() size: PivotSize = 'medium';

  isFirstTime: boolean = false;

  @HostBinding('class.size-tiny')
  get tiny() {
    return this.size === 'tiny';
  }

  @HostBinding('class.size-giant')
  get giant() {
    return this.size === 'giant';
  }
}
